import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CareersComponent } from './about-us';
import {
  HomeComponent,
  ContactUsComponent,
  PartnerComponent,
  ErrorPageComponent,
  SupportComponent,
  ProductComponent,
  TermsOfUsComponent,
  PrivacyPolicyComponent
} from '../app';
import { QuicklinkStrategy } from 'ngx-quicklink';
import { InvestorsComponent } from './investors/investors.component';
import { CustomSoftwareDevelopmentComponent } from './custom-software-development/custom-software-development.component';
import { GccFlexComponent } from './gcc-flex/gcc-flex.component';
import { LegacySystemMigrationComponent } from './legacy-system-migration/legacy-system-migration.component';
import { AnalyticsComponent } from './analytics/analytics.component';
import { DronaComponent } from './drona/drona.component';
import { SamudraComponent } from './samudra/samudra.component';
import { EppsSmartErpComponent } from './epps-smart-erp/epps-smart-erp.component';
import { IndraComponent } from './indra/indra.component';
import { PrismComponent } from './prism/prism.component';
const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'resources', loadChildren: () => import('./resources/resources.module').then(m => m.ResourcesModule)},
  { path: 'about-us', loadChildren: () => import('./about-us/about-us.module').then(m => m.AboutUsModule)},
  { path: 'product', component: ProductComponent },
  { path: 'partner', component: PartnerComponent },
  { path: 'support', component: SupportComponent },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'investor-relations', component: InvestorsComponent },
  { path: 'careers', component: CareersComponent },
  { path: 'terms-of-us', component: TermsOfUsComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'custom-software-development', component: CustomSoftwareDevelopmentComponent },
  { path: 'gcc-flex', component: GccFlexComponent },
  { path: 'legacy-system-migration', component: LegacySystemMigrationComponent },
  { path: 'analytics', component: AnalyticsComponent },
  { path: 'drona', component: DronaComponent },
  { path: 'samudra', component: SamudraComponent },
  { path: 'epps-smart-erp', component: EppsSmartErpComponent },
  { path: 'indra', component: IndraComponent },
  { path: 'prism', component: PrismComponent },
  { path: '**', component: ErrorPageComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, scrollPositionRestoration: 'top', preloadingStrategy: QuicklinkStrategy })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
